<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="deaths-not-over">
<h1>Death’s Not Over</h1>
<p style="text-indent:0px;">Death knocks at all of our doors,</p>
<p style="text-indent:0px;">Out time will come unknowing.</p>
<p style="text-indent:0px;">We cannot live thinking of our death’s cause,</p>
<p style="text-indent:0px;">We will never know when it is coming.</p><br/>
<p style="text-indent:0px;">Terminal disease is not an ending,</p>
<p style="text-indent:0px;">Unfortunately though the pain must be felt.</p>
<p style="text-indent:0px;">It is actually just the magical beginning,</p>
<p style="text-indent:0px;">Of your next journey for new cards to be dealt.</p><br/>
<p style="text-indent:0px;">Painful memories fade into oblivion,</p>
<p style="text-indent:0px;">Replaced by forgotten joy.</p>
<p style="text-indent:0px;">That single moment that was one in a million,</p>
<p style="text-indent:0px;">Conquers pained loss like the surprise of Troy.</p><br/>
<p style="text-indent:0px;">The mourning of a loved one,</p>
<p style="text-indent:0px;">It too shall have resolve.</p>
<p style="text-indent:0px;">Even though they are now physically gone,</p>
<p style="text-indent:0px;">They remain in the form of their soul.</p><br/>
<p style="text-indent:0px;">Only silent words need be uttered,</p>
<p style="text-indent:0px;">About a moral man dedicated to love.</p>
<p style="text-indent:0px;">For not a feather had he fluttered,</p>
<p style="text-indent:0px;">A true gentleman looks down now from above.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?112cca70